import React, { createContext, useState } from 'react'

export const OrderIdContext = createContext()

const OrderIdContextProvider = ({ children }) => {
    const [orderId, setOrderId] = useState(null)

    const changeOrderId = orderNumber => {
        setOrderId(orderNumber)
    }

    const contextValues = {
        orderId,
        changeOrderId,
    }

    return <OrderIdContext.Provider value={contextValues}>{children}</OrderIdContext.Provider>
}
export default OrderIdContextProvider
